import { useState, useCallback } from 'react';
import { api } from './api';
import useTheme from './hooks/useTheme';
import Sidebar          from './components/Sidebar';
import Dashboard        from './pages/Dashboard';
import SalesReport      from './pages/SalesReport';
import PaymentReport    from './pages/PaymentReport';
import CustomersPage    from './pages/CustomersPage';
import StatesPage       from './pages/StatesPage';
import TransactionsPage from './pages/TransactionsPage';
import './index.css';

const PAGE_TITLES = {
  dashboard:    'Dashboard',
  sales:        'Sales Report',
  payment:      'Payment Report',
  customers:    'Customers',
  states:       'States',
  transactions: 'Transactions',
};

const today29 = () => {
  const d = new Date(); d.setDate(d.getDate() - 29);
  return d.toISOString().split('T')[0];
};

export default function App() {
  const [page,       setPage]       = useState('dashboard');
  const [collapsed,  setCollapsed]  = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [toast,      setToast]      = useState(null);
  const { theme, toggleTheme } = useTheme();

  const showToast = useCallback((msg, type = 'success') => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3500);
  }, []);

  const handleRefresh = async () => {
    await api.refreshCache();
    showToast('Data refreshed from Excel file');
  };

  const handleEmail = async () => {
    showToast('Sending report email…');
    try {
      const res = await api.triggerReport(new Date().toISOString().split('T')[0]);
      showToast(res.success ? '✅ Report emailed!' : `❌ ${res.error}`, res.success ? 'success' : 'error');
    } catch { showToast('Email failed — check backend config', 'error'); }
  };

  const handleDownload = () => {
    api.download(today29(), new Date().toISOString().split('T')[0]);
    showToast('Downloading Excel report…');
  };

  return (
    <div className="app-shell">

      {/* ── Toast ─────────────────────────────── */}
      {toast && (
        <div className="toast" style={{
          background: toast.type === 'error' ? 'var(--toast-error-bg)' : 'var(--toast-success-bg)',
          color:      toast.type === 'error' ? 'var(--toast-error-text)' : 'var(--toast-success-text)',
          border:    `1px solid ${toast.type === 'error' ? 'var(--toast-error-border)' : 'var(--toast-success-border)'}`,
        }}>
          {toast.msg}
        </div>
      )}

      {/* ── Sidebar ───────────────────────────── */}
      <Sidebar
        page={page} setPage={setPage}
        collapsed={collapsed} setCollapsed={setCollapsed}
        mobileOpen={mobileOpen} setMobileOpen={setMobileOpen}
      />

      {/* ── Main area ─────────────────────────── */}
      <div className="main-area">

        {/* Top header */}
        <header className="top-header">
          <div className="header-left">
            <button
              onClick={() => setMobileOpen(o => !o)}
              className="mobile-ham"
              style={{ background:'rgba(255,255,255,.15)', border:'1px solid rgba(255,255,255,.3)', borderRadius:'8px', color:'#fff', padding:'7px 10px', fontSize:'16px', marginRight:'4px', cursor:'pointer', fontFamily:'inherit', display:'none' }}>
              ☰
            </button>
            <div>
              <div className="header-title">{PAGE_TITLES[page]}</div>
              <div className="header-sub">DARJUV9 Enterprises · dummy_record.xlsx</div>
            </div>
          </div>

          <div className="header-right">
            <button
              className="theme-toggle"
              onClick={toggleTheme}
              title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            >
              {theme === 'dark' ? '☀️' : '🌙'}
            </button>
            <button className="hdr-btn" onClick={handleRefresh}>
              <span>🔄</span><span>Refresh</span>
            </button>
            <button className="hdr-btn" onClick={handleDownload}>
              <span>⬇</span><span>Download</span>
            </button>
            <button className="hdr-btn primary" onClick={handleEmail}>
              <span>📧</span><span>Email Report</span>
            </button>
          </div>
        </header>

        {/* Page content */}
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {page === 'dashboard'    && <Dashboard        showToast={showToast} />}
          {page === 'sales'        && <SalesReport      showToast={showToast} />}
          {page === 'payment'      && <PaymentReport    showToast={showToast} />}
          {page === 'customers'    && <CustomersPage    showToast={showToast} />}
          {page === 'states'       && <StatesPage       showToast={showToast} />}
          {page === 'transactions' && <TransactionsPage                       />}
        </div>

        {/* Footer */}
        {/* <div style={{ textAlign:'center', fontSize:'11px', color:'var(--muted)', padding:'10px 20px', borderTop:'1px solid var(--border)', background:'#fff', flexShrink:0 }}>
           · {new Date().toLocaleDateString('en-IN')}
        </div> */}
      </div>

      <style>{`
        .mobile-ham { display: none !important; }
        @media (max-width: 768px) { .mobile-ham { display: block !important; } }
      `}</style>
    </div>
  );
}
